<!--
Copyright 2026 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information.
-->
<crucible-dialog dialogTitle="Competency Detail" [hideDefaultActions]="true">
  <div crucibleDialogContent>
    <div class="detail-row">
      <span class="detail-label">ID</span>
      <span>{{ data.competency.idNumber }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">Name</span>
      <span>{{ data.competency.shortName }}</span>
    </div>
    @if (getType()) {
    <div class="detail-row">
      <span class="detail-label">Type</span>
      <span>{{ getType() }}</span>
    </div>
    }
    @if (data.competency.description) {
    <div class="detail-row">
      <span class="detail-label">Description</span>
      <span>{{ data.competency.description }}</span>
    </div>
    }
  </div>

  <ng-container crucibleDialogActions>
    <button matButton="filled" type="button" (click)="close()">Close</button>
  </ng-container>
</crucible-dialog>
